export const PRODUCT_TYPE = {
  PRODUCTS: 'PRODUCTS',
  IS_LOADING: 'IS_LOADING',
  PRODUCT_RESPONSE: 'PRODUCT_RESPONSE',
  PRODUCT_DETAILS: 'PRODUCT_DETAILS',
  ERROR: 'ERROR',
  REVIEW_LOADING: 'REVIEW_LOADING',
  REVIEWS: 'REVIEWS',
};
